// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-1Hrdm";
var _4 = "title-2I4Lo";
var _5 = "icon-1VDEG";
var _6 = "conditions-1_9Pi";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "title", _5 as "icon", _6 as "conditions" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "title": _4, "icon": _5, "conditions": _6 }
